<template>
	<div>
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'impresso',
}
</script>


// WEBPACK FOOTER //
// Impresso.vue?5966ecaa